/* Beylora: "Added to Cart" signal for Klaviyo cart emails (piece T of the cart-email build, 2026-11-01).
   After any successful POST to /cart/add or /cart/add.js (fetch or XMLHttpRequest, with or without a
   locale prefix) it reads /cart.js once and sends one Klaviyo event with the whole cart.
   Contract: ops/cart-recovery/CONTRACT.md. Tests: ops/cart-recovery/test/cart_signal.test.mjs.
   Engraving (2026-11-03): Lead and every Items entry carry Engraved, a boolean; the engraved words never
   leave the browser (test: ops/cart-recovery/test/engraving_cart_signal.test.mjs).
   Rules it keeps: never throws, never delays or blocks the add (the add's own promise is returned
   untouched), one event per add. A plain HTML form post that leaves the page is not covered; the theme
   has none (product-form-component submits by fetch). When the page leaves right after an add (the set
   builder goes to /cart), the unfinished add is kept in sessionStorage and sent by the next page.
   Night hold (2026-11-04, cart recovery redesign): Joe approved that night sends wait until 8 AM Mountain. Email 1
   goes out 1 hour after the event, so every event carries NightHold, a boolean: true when the moment 1 hour after
   the event falls from 21:00 through 07:59 America/Denver. Klaviyo branches on it and waits until 08:00.
   Shopify's own Checkout Started has no such field, so a Check out click (the Check out button in the bag and on
   /cart, and the accelerated buttons beside it) posts one "Checkout Clicked" event through the same route with
   NightHold, Eligible and $value. It never blocks the click, never calls preventDefault, never throws.
   Tests: ops/cart-recovery/test/cart_signal.test.mjs and nighthold.test.mjs. */
(function (root) {
  'use strict';

  var EVENT = 'Added to Cart';
  var CLICK_EVENT = 'Checkout Clicked';
  /* the Check out button (bag and /cart page share it) and the accelerated buttons container in the cart summary */
  var CHECKOUT_SELECTOR = 'button[name="checkout"], .additional-checkout-buttons';
  var CODE = 'BEYLORA100';
  var ORIGIN = 'https://beylora.com';
  var PENDING_KEY = 'bey_cart_signal_pending';
  var PENDING_MAX_AGE = 2 * 60 * 1000;
  var ADD_PATH = /^(?:\/[a-z]{2}(?:-[a-z0-9]{2,8})?)?\/cart\/add(?:\.js)?\/?$/i;

  /* ---------- pure payload builder (cart JSON from /cart.js in, props out) ---------- */

  function formatMoney(n) {
    n = Number(n);
    if (!isFinite(n)) n = 0;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    var s = (whole ? String(Math.round(Math.abs(n))) : Math.abs(n).toFixed(2));
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (n < 0 ? '-$' : '$') + parts.join('.');
  }

  /* "Lab-Grown Diamond / 2 ct / 14k White Gold" -> "2ct, 14K White Gold"; "14k White Gold" -> "14K White Gold" */
  function specFromVariant(title) {
    if (title === null || title === undefined) return '';
    var raw = String(title).trim();
    if (!raw || /^default title$/i.test(raw)) return '';
    var out = [];
    var bits = raw.split('/');
    for (var i = 0; i < bits.length; i++) {
      var b = bits[i].trim();
      if (!b) continue;
      if (/^lab[- ]grown diamond$/i.test(b)) continue;
      var ct = b.match(/^(\d+(?:\.\d+)?)\s*ct$/i);
      if (ct) { out.push(ct[1] + 'ct'); continue; }
      out.push(b.replace(/^(\d+)k\b/i, function (m, d) { return d + 'K'; }));
    }
    return out.join(', ');
  }

  /* carat (number or null) and metal (the metal option exactly as Shopify has it, "" when none) from the variant title */
  function caratAndMetal(title) {
    var carat = null, metal = '';
    if (title === null || title === undefined) return { carat: carat, metal: metal };
    var raw = String(title).trim();
    if (!raw || /^default title$/i.test(raw)) return { carat: carat, metal: metal };
    var bits = raw.split('/');
    for (var i = 0; i < bits.length; i++) {
      var b = bits[i].trim();
      if (!b || /^lab[- ]grown diamond$/i.test(b)) continue;
      var ct = b.match(/^(\d+(?:\.\d+)?)\s*ct$/i);
      if (ct) { carat = Number(ct[1]); continue; }
      if (!metal) metal = b;
    }
    return { carat: carat, metal: metal };
  }

  function imageUrl(it) {
    var u = (it.featured_image && it.featured_image.url) || it.image || '';
    if (!u || typeof u !== 'string') return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    try {
      var x = new URL(u, ORIGIN + '/');
      x.protocol = 'https:';
      x.searchParams.set('width', '800');
      return x.toString();
    } catch (e) { return ''; }
  }

  function lineFields(it) {
    var handle = it.handle || '';
    var variant = it.variant_id || it.id || '';
    var path = '/products/' + handle + '?variant=' + variant;
    var title = it.product_title || it.title || '';
    var props = it.properties && typeof it.properties === 'object' ? it.properties : {};
    var size = props['Ring Size'];
    /* engraving: only whether the line has one leaves the browser, never the words or the font (emails print a fixed line) */
    var words = props['Engraving'];
    var line = Number(it.original_line_price);
    if (!isFinite(line)) line = Number(it.original_price) * (Number(it.quantity) || 1);
    if (!isFinite(line)) line = 0;
    var pid = Number(it.product_id), vid = Number(variant);
    var qty = Number(it.quantity) || 1;
    var cm = caratAndMetal(it.variant_title);
    return {
      ProductId: isFinite(pid) && it.product_id !== undefined && it.product_id !== null && it.product_id !== '' ? pid : null,
      VariantId: isFinite(vid) && variant !== '' ? vid : null,
      Handle: handle,
      ProductName: title,
      ShortName: String(title).replace(/\s+Lab-Grown Diamond Ring$/i, ''),
      Type: it.product_type || '',
      Spec: specFromVariant(it.variant_title),
      RingSize: size === undefined || size === null ? '' : String(size),
      Engraved: words !== undefined && words !== null && String(words).trim() !== '',
      PriceText: formatMoney(line / 100),
      Price: line / 100 / qty,
      LinePrice: line / 100,
      Carat: cm.carat,
      Metal: cm.metal,
      ImageURL: imageUrl(it),
      URL: ORIGIN + path,
      RecoverURL: ORIGIN + '/discount/' + CODE + '?redirect=' + encodeURIComponent(path)
    };
  }

  var lastStamp = 0;
  function stamp(now) {
    var t = typeof now === 'number' ? now : Date.now();
    if (typeof now !== 'number' && t <= lastStamp) t = lastStamp + 1;
    if (typeof now !== 'number') lastStamp = t;
    return t;
  }

  /* true when the moment 1 hour after nowMs is 21:00 through 07:59 in America/Denver (DST included by Intl).
     Never throws: any error returns false, which is the behaviour before the night hold existed. */
  function nightHold(nowMs) {
    try {
      var h = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', hour: 'numeric', hourCycle: 'h23' }).format(new Date(nowMs + 3600000)));
      return h >= 21 || h < 8;
    } catch (e) { return false; }
  }

  function buildProps(cart, opts) {
    opts = opts || {};
    var items = cart && Array.isArray(cart.items) ? cart.items.filter(function (x) { return x && typeof x === 'object'; }) : [];
    var cents = 0, count = 0, hasRing = false, hasBand = false, ring = null, band = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var q = Number(it.quantity) || 0;
      var lp = Number(it.original_line_price);
      if (!isFinite(lp)) lp = (Number(it.original_price) || 0) * q;
      cents += lp;
      count += q;
      if (it.product_type === 'Engagement Ring') { hasRing = true; if (!ring) ring = it; }
      if (it.product_type === 'Wedding Band') { hasBand = true; if (!band) band = it; }
    }
    var value = cents / 100;
    var eligible = hasRing || hasBand;
    var leadLine = ring || band || items[0] || null;
    var token = cart && typeof cart.token === 'string' ? cart.token.split('?')[0] : '';
    return {
      $event_id: token + '-' + stamp(opts.now),
      $value: value,
      Eligible: eligible,
      NightHold: nightHold(typeof opts.now === 'number' ? opts.now : Date.now()),
      BandOnly: hasBand && !hasRing,
      TotalText: formatMoney(value),
      CodeTotalText: eligible && value > 100 ? formatMoney(value - 100) : '',
      ItemCount: count,
      ItemNames: items.map(function (x) { return x.product_title || x.title || ''; }),
      Lead: leadLine ? lineFields(leadLine) : {},
      Items: items.map(function (x) {
        var f = lineFields(x);
        f.Quantity = Number(x.quantity) || 0;
        return f;
      })
    };
  }

  /* ---------- which requests are adds ---------- */

  function isAddRequest(url, method, origin) {
    try {
      if (String(method || '').toUpperCase() !== 'POST') return false;
      var base = origin || (root.location && root.location.origin) || ORIGIN;
      var u = new URL(String(url), base);
      if (u.host !== new URL(base).host) return false;
      return ADD_PATH.test(u.pathname);
    } catch (e) { return false; }
  }

  /* ---------- sending ---------- */

  function sendEvent(win, name, props) {
    try {
      var k = win.klaviyo;
      if (k && typeof k.push === 'function') k.push(['track', name, props]);
      else if (k && typeof k.track === 'function') k.track(name, props);
      else { win._klOnsite = win._klOnsite || []; win._klOnsite.push(['track', name, props]); }
    } catch (e) { /* never break the page */ }
  }
  function sendToKlaviyo(win, props) { sendEvent(win, EVENT, props); }

  /* the three properties a Checkout Clicked event carries, taken from the same cart read and the same rules as Added to Cart */
  function buildClickProps(cart, opts) {
    var p = buildProps(cart, opts);
    return { $event_id: p.$event_id, $value: p.$value, Eligible: p.Eligible, NightHold: p.NightHold };
  }

  /* the Check out button or accelerated container this click landed on, or null (shadow DOM buttons retarget to their host) */
  function checkoutTarget(ev) {
    try {
      var path = typeof ev.composedPath === 'function' ? ev.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && typeof n.matches === 'function' && n.matches(CHECKOUT_SELECTOR)) return n;
      }
      var t = ev.target;
      return t && typeof t.closest === 'function' ? t.closest(CHECKOUT_SELECTOR) : null;
    } catch (e) { return null; }
  }

  function readPending(win) {
    try {
      var raw = win.sessionStorage.getItem(PENDING_KEY);
      var m = raw ? JSON.parse(raw) : {};
      return m && typeof m === 'object' ? m : {};
    } catch (e) { return {}; }
  }
  function writePending(win, m) {
    try {
      if (Object.keys(m).length) win.sessionStorage.setItem(PENDING_KEY, JSON.stringify(m));
      else win.sessionStorage.removeItem(PENDING_KEY);
    } catch (e) { /* storage blocked: the same-page path still works */ }
  }

  function install(win) {
    if (!win || win.__beyCartSignalInstalled) return;
    win.__beyCartSignalInstalled = true;
    var origFetch = typeof win.fetch === 'function' ? win.fetch : null;
    var seq = 0;

    function readCart() {
      if (!origFetch) return Promise.reject(new Error('no fetch'));
      return origFetch.call(win, '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { if (!r || !r.ok) throw new Error('cart read ' + (r && r.status)); return r.json(); });
    }

    function finish(id) {
      /* returns true when this add is still ours to send (not claimed by a later page) */
      var m = readPending(win);
      var mine = Object.prototype.hasOwnProperty.call(m, id);
      if (mine) { delete m[id]; writePending(win, m); }
      return mine || !hasStorage(win);
    }

    function hasStorage(w) {
      try { w.sessionStorage.setItem('bey_cart_signal_probe', '1'); w.sessionStorage.removeItem('bey_cart_signal_probe'); return true; } catch (e) { return false; }
    }

    function onAdded() {
      try {
        var id = String(Date.now()) + '-' + (++seq);
        var m = readPending(win);
        m[id] = Date.now();
        writePending(win, m);
        readCart().then(function (cart) {
          try {
            if (!finish(id)) return;
            sendToKlaviyo(win, buildProps(cart));
          } catch (e) { /* ignore */ }
        }, function () {
          try { finish(id); } catch (e) { /* ignore */ }
        });
      } catch (e) { /* ignore */ }
    }

    /* Check out click: one Checkout Clicked event, read and sent after the click, never in its way. The listener only
       observes (no preventDefault, no stopPropagation). Capture phase so a handler that stops the click cannot hide it.
       The theme's own checkout script re-clicks the button with a bypass flag when its redirect fails: that second
       click is skipped, so one shopper click makes one event. */
    function onCheckoutClick(ev) {
      try {
        if (!ev || ev.__beyCheckoutSeen) return;
        ev.__beyCheckoutSeen = true;
        var target = checkoutTarget(ev);
        if (!target) return;
        if (target.dataset && target.dataset.beyloraCheckoutBypass === 'true') return;
        readCart().then(function (cart) {
          try {
            if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
            sendEvent(win, CLICK_EVENT, buildClickProps(cart));
          } catch (e) { /* ignore */ }
        }, function () { /* ignore */ });
      } catch (e) { /* ignore */ }
    }
    try {
      if (win.document && typeof win.document.addEventListener === 'function') {
        win.document.addEventListener('click', onCheckoutClick, { capture: true, passive: true });
      }
    } catch (e) { /* ignore */ }

    /* fetch: the caller gets the real promise back untouched */
    if (origFetch) {
      win.fetch = function (input, init) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && (input.url || String(input)));
          var method = (init && init.method) || (input && input.method) || 'GET';
          if (isAddRequest(url, method, win.location && win.location.origin)) {
            p.then(function (res) { try { if (res && res.ok) onAdded(); } catch (e) { /* ignore */ } }, function () { /* the caller handles it */ });
          }
        } catch (e) { /* ignore */ }
        return p;
      };
    }

    /* XMLHttpRequest */
    var proto = win.XMLHttpRequest && win.XMLHttpRequest.prototype;
    if (proto && typeof proto.open === 'function' && typeof proto.send === 'function') {
      var origOpen = proto.open, origSend = proto.send;
      proto.open = function (method, url) {
        try {
          this.__beyCs = { add: isAddRequest(url, method, win.location && win.location.origin), done: false, attached: false };
        } catch (e) { /* ignore */ }
        return origOpen.apply(this, arguments);
      };
      proto.send = function () {
        try {
          var st = this.__beyCs;
          if (st && st.add && !st.attached && typeof this.addEventListener === 'function') {
            st.attached = true;
            var xhr = this;
            this.addEventListener('load', function () {
              try {
                if (!st.done && xhr.status >= 200 && xhr.status < 300) { st.done = true; onAdded(); }
              } catch (e) { /* ignore */ }
            });
          }
        } catch (e) { /* ignore */ }
        return origSend.apply(this, arguments);
      };
    }

    /* adds the previous page left unfinished (it navigated away mid-read): this page sends them once */
    try {
      var pending = readPending(win);
      var ids = Object.keys(pending);
      if (ids.length) {
        writePending(win, {});
        var fresh = ids.filter(function (k) { return Date.now() - Number(pending[k]) < PENDING_MAX_AGE; });
        if (fresh.length) {
          readCart().then(function (cart) {
            try { for (var j = 0; j < fresh.length; j++) sendToKlaviyo(win, buildProps(cart)); } catch (e) { /* ignore */ }
          }, function () { /* ignore */ });
        }
      }
    } catch (e) { /* ignore */ }
  }

  var api = {
    EVENT: EVENT,
    CLICK_EVENT: CLICK_EVENT,
    nightHold: nightHold,
    buildClickProps: buildClickProps,
    buildProps: buildProps,
    formatMoney: formatMoney,
    specFromVariant: specFromVariant,
    caratAndMetal: caratAndMetal,
    isAddRequest: isAddRequest,
    install: install
  };
  try { root.BeyloraCartSignal = api; } catch (e) { /* ignore */ }
  if (typeof module !== 'undefined' && module && module.exports) module.exports = api;
  try { if (root && root.document) install(root); } catch (e) { /* never break the page */ }
})(typeof window !== 'undefined' ? window : this);
